import { Badge, Icon, notification, Popover } from 'antd';
import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import mp3Src from 'src/assets/audio/newOrder.mp3';
import oggSrc from 'src/assets/audio/newOrder.ogg';
import { RouterConfig } from 'src/routers/urlConfig';
import I18N from 'src/services/I18NService';
import { OperatingService } from 'src/services/OperatingService';
import { MddCommon } from '@macrocura/utils';

interface NotifyLayoutProps extends RouteComponentProps {
  isAgent: boolean;
  approveCount: number;
  needConfigureCount: number;
  orderCount: number;
  hasNewOrder: boolean;
  updateMenu: (pathName: string) => void;
  setNewOrder: (order: number, hasNewOrder: boolean) => void;
}

class NotifyLayout extends React.Component<NotifyLayoutProps> {
  // audioRef: React.RefObject<HTMLAudioElement>;
  audioRef: React.RefObject<HTMLAudioElement> = React.createRef();

  constructor(props: NotifyLayoutProps) {
    super(props);
  }

  componentDidMount() {
    if (!!this.props.hasNewOrder) {
      this.showOrderNotification();
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps: NotifyLayoutProps) {
    if (!!nextProps.hasNewOrder) {
      this.showOrderNotification();
    }
  }

  showOrderNotification = async () => {
    const hasOperate = OperatingService.hasOperate();
    if (hasOperate && !!this.audioRef.current) {
      notification.open({
        message: I18N.get('common_system_hint'),
        description: I18N.get('order_new_to_process'),
      });

      await MddCommon.sleep(500);

      this.audioRef.current.play();

      this.props.setNewOrder(this.props.orderCount, false);
    }
  };

  handleToConfigure = () => {
    this.props.updateMenu(RouterConfig.Urls.userDoctorNoSetting);
    this.props.history.push(RouterConfig.Urls.userDoctorNoSetting);
  };

  handleToApprove = () => {
    this.props.updateMenu(RouterConfig.Urls.userAudit);
    this.props.history.push(RouterConfig.Urls.userAudit);
  };

  handleToOrder = () => {
    this.props.updateMenu(RouterConfig.Urls.order);
    this.props.history.push(RouterConfig.Urls.order);
  };

  render() {
    const { isAgent, approveCount, needConfigureCount, orderCount } = this.props;

    const count = approveCount + needConfigureCount + orderCount;
    const text = (
      <span>
        {I18N.get('common_status_pending')}({count})
      </span>
    );
    const content = isAgent ? (
      <div>
        <p>
          <a onClick={this.handleToApprove}>
            {I18N.get('nav_user_audit')}：<span style={{ color: 'red' }}>{approveCount} </span>
          </a>
        </p>
        <p>
          <a onClick={this.handleToConfigure}>
            {I18N.get('nav_user_doctor_no_setting')}：<span style={{ color: 'red' }}>{needConfigureCount}</span>
          </a>
        </p>
      </div>
    ) : (
      <div>
        <p>
          <a onClick={this.handleToOrder}>
            {I18N.get('common_status_pending') + I18N.get('common_orders')}：<span style={{ color: 'red' }}>{orderCount}</span>
          </a>
        </p>
      </div>
    );
    return (
      <div className="header-notify">
        <audio ref={this.audioRef}>
          <source src={oggSrc} type="audio/ogg" />
          <source src={mp3Src} type="audio/mpeg" />
          {I18N.get('err_not_support_audio')}
        </audio>
        <Badge count={count}>
          <Popover placement="bottomRight" title={text} content={content} trigger="hover">
            <Icon type="bell" />
          </Popover>
        </Badge>
      </div>
    );
  }
}

export default withRouter(NotifyLayout);



// WEBPACK FOOTER //
// ./src/components/layouts/NotifyLayout.tsx